<template>
  <div class="deduction-detail">
    <div class="page-header">
      <a-page-header title="扣款信息" :ghost="true">
        <template slot="extra">
          <a-button type="primary" @click="goBack()"> 返 回 </a-button>
        </template>
        <a-descriptions size="small" :column="2">
          <a-descriptions-item>
            <i class="iconfont icon-icon-user"></i>
            <div>租户名称：{{ deductions.tenatName || "--" }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <i class="iconfont icon-shijian"></i>
            <div>创建时间：{{ deductions.dateCreated || "--" }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <i class="iconfont icon-shouji"></i>
            <div>联系方式：{{ deductions.contactPhone || "--" }}</div>
          </a-descriptions-item>
          <a-descriptions-item>
            <i class="iconfont icon-jiesuanguanli"></i>
            <div>
              扣费结算周期：{{ deductions.preDate || "--" }}~{{
                deductions.endDate || "--"
              }}
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </a-page-header>
    </div>
    <div class="table" id="table">
      <div
        style="display: flex; align-items: center; justify-content: flex-end"
      >
        <a-button type="primary" @click="onExport">导出Excel</a-button>
      </div>
      <a-table
        rowKey="id"
        :scroll="{ x: 1100 }"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="pagination"
        @change="(pagination) => getDeductionDetail(pagination.current - 1)"
      >
      </a-table>
    </div>
  </div>
</template>
<script>
import { contractWalletUseFlowPage } from "./service";
import { domainStr } from "../../../utils/request";
import scrollbarInit from "../../../utils/perfectScrollBar";
const columns = [
  {
    title: "序号",
    dataIndex: "index",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "流水号",
    dataIndex: "orderNo",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "结算开始时间",
    dataIndex: "preDate",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "结算结束时间",
    dataIndex: "endDate",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "创建时间",
    dataIndex: "dateCreated",
    customRender: (text) => {
      return text || "--";
    },
  },
  {
    title: "扣费金额",
    dataIndex: "useNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "扣费前余额",
    dataIndex: "preNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
  {
    title: "扣费后余额",
    dataIndex: "afterNumber",
    customRender: (text) => {
      return text || "0";
    },
  },
];
export default {
  data() {
    return {
      deductions: {},
      columns,
      dataSource: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  created() {
    let deductions = JSON.parse(this.$route.query.deductions);
    this.deductions = deductions;
    this.getDeductionDetail();
  },
  mounted() {
    this.createScroll();
  },
  methods: {
    createScroll() {
      const scrollBar = scrollbarInit("#table");
      const dom = document.querySelector("#table");
      dom.scrollTop = 0;
      scrollBar.update();
    },
    goBack() {
      this.$router.push({ path: "/app/signing/financialmanage" });
    },
    async getDeductionDetail(pageNo = 0) {
      try {
        const params = {
          contractBillId: this.deductions.id,
          pageNo,
          pageSize: 10,
        };

        const res = await contractWalletUseFlowPage.request(params, {
          showBizRemind: true,
        });

        if (res.bizCode === 1) {
          let data = [];
          res.data.items.map((item, index) => {
            data.push({ ...item, index: index + 1 });
          });
          this.dataSource = data;
          this.pagination = {
            current: res.data.pageNo + 1,
            pageSize: 10,
            total: res.data.totalCount,
          };
        }
      } catch (err) {
        console.error(err);
      }
    },
    async onExport() {
      try {
        let url = `${domainStr}/v2/contract/bill/details/deduction/export?contractBillId=${this.deductions.id}`;

        const a = document.createElement("a");
        a.href = url;
        a.download = "扣费明细.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.deduction-detail {
  width: 100%;
  > .page-header {
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    height: .convertPxToDesighVH(220) [];
    > .ant-page-header {
      background: transparent;
      height: .convertPxToDesighVH(220) [];
      box-sizing: border-box;
      border-radius: .convertPxToDesighVH(10) [];
    }
  }
  > .table {
    margin-top: .convertPxToDesighVH(20) [];
    background: #192430;
    border: .convertPxToDesighVH(2) [] solid #293646;
    border-radius: .convertPxToDesighVH(10) [];
    padding: .convertPxToDesighVH(20) [];
    height: calc(100vh - .convertPxToDesighVH(350) []);
    // overflow: auto;
    > .ant-btn {
      margin-bottom: .convertPxToDesighVH(20) [];
    }
    div {
      margin-bottom: .convertPxToDesighVH(16) [];
    }
  }
}

#table {
  position: relative;
  overflow: hidden;
}
</style>
